import React, { useState, useEffect, useRef } from "react";
import { Box, TextInput } from "grommet";
import CommonButton from "../../../common/Button/CommonButton";
import CommonSearchInput from "../../../common/SearchInput/CommonSearchInput";
import "./Flight.css";
import { DataTable, Text } from "grommet";
import { useStore } from "../../../../../../Hooks/useStore";
import { FlightService } from "../../../../../../services/flights/flight.service";
import editsquare from "../../../../../../assets/edit_square.svg";
import filtericon from "../../../../../../assets/filter_list.svg";
import { observer } from "mobx-react";
import FlightEditForm from "./FlightEditForm";
import AddFlight from "./AddFlight";
import { format } from "date-fns";
import searchIcon from "../../../../../../assets/search.svg";
import userActionDropdown from "../../../../../../assets/arrow_drop_down (1).svg";
import NoDataFound from "../../../../../../assets/urban-no-data-found-3 1.png";
import createuserService from "../Users/CreateUser/createuser.service";
import usersService from "../Users/users.service";
import { AxiosError } from "axios";
import Passengerspagination from "../../../common/Pagination/Pagination";
import Pagination from "../../../common/Pagination/Pagination";

const Flights = observer(() => {
  const { rootStore } = useStore();
  const [searchString, setSearchString] = useState("");
  const [originalFlightList, setOriginalFlightList] = useState([]);
  const [sortedFlightList, setSortedFlightList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [flightToEdit, setFlightToEdit] = useState(null);
  const [isEditFormOpen, setIsEditFormOpen] = useState(false);
  const [isAddFlightOpen, setIsAddFlightOpen] = useState(false);
  const [showFilterOptions, setShowFilterOptions] = useState(false);

  const filterDropdownRef = useRef(null); // Add ref for filter dropdown

  const itemsPerPage = 10;

  // Add useEffect for click-outside detection for filter dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterDropdownRef.current && !filterDropdownRef.current.contains(event.target)) {
        if (showFilterOptions) {
          setShowFilterOptions(false);
        }
      }
    };

    // Add event listener
    document.addEventListener('mousedown', handleClickOutside);
    
    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFilterOptions]);

  useEffect(() => {
    getFlights();
  }, [rootStore.flightsStore.getupdate, rootStore.flightsStore.getUserOId]);

  const getFlights = async () => {
    if (rootStore.flightsStore.getUserOId) {
      try {
        rootStore.loadingStore.setShowLoader(true);
        const flightsData = await FlightService.getOrgDrop(
          rootStore.flightsStore.getUserOId
        );
        rootStore.flightsStore.handleflightlist(flightsData);
        setOriginalFlightList(flightsData);
        setSortedFlightList(flightsData.slice(0, itemsPerPage)); // Initialize sorted list with first page
        rootStore.loadingStore.setShowLoader(false);
      } catch (error) {
        console.error("Error fetching flights:", error);
      }
    } else {
      try {
        rootStore.loadingStore.setShowLoader(true);
        const flightsData = await FlightService.listFlights();
        rootStore.flightsStore.handleflightlist(flightsData);
        setOriginalFlightList(flightsData);
        setSortedFlightList(flightsData.slice(0, itemsPerPage)); // Initialize sorted list with first page
        rootStore.loadingStore.setShowLoader(false);
      } catch (error) {
        console.error("Error fetching flights:", error);
      }
    }
  };

  useEffect(() => {
    // Update sortedFlightList based on currentPage and itemsPerPage
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setSortedFlightList(originalFlightList.slice(startIndex, endIndex));
  }, [currentPage, itemsPerPage, originalFlightList]);

  const sortFlights = (sortBy) => {
    let sortedList = [...originalFlightList];
    if (sortBy === "oldest") {
      sortedList.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    } else if (sortBy === "newest") {
      sortedList.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    }
    setOriginalFlightList(sortedList);
    setCurrentPage(1); // Reset to first page when sorting changes
  };

  const toggleEditForm = (flightId) => {
    try {
      FlightService.getFlight(flightId).then((flightResponse) => {
        rootStore.flightsStore.handleId(flightResponse.id);
        rootStore.flightsStore.handleflightID(flightId);
        rootStore.flightsStore.handleMsn(flightResponse.msn);
        rootStore.flightsStore.handleTailNumber(flightResponse.tailNumber);
        rootStore.flightsStore.handleFleetType(flightResponse.fleetType);
        rootStore.flightsStore.handleWifiProvider(flightResponse.wifiProvider);
        rootStore.flightsStore.handleOrg(flightResponse.organization.id);
        // rootStore.flightsStore.handleSpecificFlights(flightResponse);
        setIsEditFormOpen(!isEditFormOpen);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const onSearchStrChange = (value) => {
    setSearchString(value);
    if (value.trim() === "") {
      rootStore.flightsStore.handleflightlist(originalFlightList);
      setSortedFlightList(
        originalFlightList.slice(
          (currentPage - 1) * itemsPerPage,
          currentPage * itemsPerPage
        )
      );
    }
  };

  const onSearch = (value) => {
    const filteredFlights = originalFlightList.filter((item) => {
      let matches = false;

      if (
        item.tailNumber &&
        item.tailNumber.toLowerCase().includes(value.toLowerCase())
      ) {
        matches = true;
      }
      if (item.fleetType) {
        if (item.fleetType.toLowerCase().includes(value.toLowerCase())) {
          matches = true;
        }
      }

      if (item.msn) {
        // console.log(item.msn)
        if (item.msn.toLowerCase().includes(value.toLowerCase())) {
          matches = true;
        }
      }
      if (item.organization.name != null) {
        if (
          item.organization.name.toLowerCase().includes(value.toLowerCase())
        ) {
          console.log("csss1");
          matches = true;
        }
      }
      if (item.wifiProvider != null) {
        if (item.wifiProvider.toLowerCase().includes(value.toLowerCase())) {
          //console.log("csss1");
          matches = true;
        }
      }

      return matches;
    });

    rootStore.flightsStore.handleflightlist(filteredFlights);

    setSortedFlightList(filteredFlights.slice(0, itemsPerPage));

    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      onSearch(searchString); // Trigger search when Enter key is pressed
    }
  };
  const organizationList = async () => {
    let organizations = await usersService.listOrganizations();
    rootStore.flightsStore.handleOrgList(organizations);
  };
  const flights = async () => {
    let allFlights = await usersService.listAllFlights();
    rootStore.flightsStore.handleFlightList(allFlights);
  };
  const wifiProvider = async () => {
    let wifiProviderList = await usersService.getWifiProvider();
    rootStore.flightsStore.handleWifiProviderList(wifiProviderList);
  };
  useEffect(() => {
    organizationList();
    flights();
    wifiProvider();
  }, []);

  const allOptions = rootStore.flightsStore.getOrgList.map((org) => (
    <option className="action-list" value={org.id} key={org.id}>
      {org.name}
    </option>
  ));

  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen((prevState) => !prevState);
  };
  const totalItems = rootStore.flightsStore.getFlightlist.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const sidebarRef = useRef(null);

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      onclose();
    }
  };

  const handleEscKey = (event) => {
    if (event.key === "Escape") {
      onclose();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscKey);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscKey);
    };
  }, []);

  let userInfo;
  useEffect(() => {
    (async () => {
      userInfo = localStorage.getItem("userinfo");
      if (userInfo) {
        let roleLabel = JSON.parse(userInfo).roleLabel;
        rootStore.adminStore.handleRoleLabel(roleLabel);
      }
    })();
  }, [userInfo]);

  return (
    <>
      <Box ref={sidebarRef} className="flights-container">
        <div className="user-activity-search">
          <div className="user-activity-blue">
            <div className="search">
              <CommonSearchInput
                style={{
                  padding: "8px 8px 8px 35px",
                  borderRadius: "10px",
                  background: "#F2F8FF",
                  outline: "0",
                  border: "none",
                  color: "#656566",
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontStyle: "normal",
                  fontWeight: "400",
                  lineHeight: "18px",
                  height: "40px",
                  maxWidth: "320px",
                  width: "320px",
                }}
                placeholder="Search"
                onchange={(e) => onSearchStrChange(e.target.value)}
                onkeydown={(e) => handleKeyDown(e)}
              />
              <CommonButton
                title="Search"
                padding="10px 24px 10px 28px"
                color="#fff"
                bgColor="#357EFF"
                radius={10}
                border="1px solid #357EFF"
                lineheight="14px"
                ml={5}
                onclick={() => onSearch(searchString)}
              />
            </div>
            <div className="addflight-container">
              <button
                style={{cursor:"pointer"}}
                className="addFlight"
                onClick={() => setIsAddFlightOpen(!isAddFlightOpen)}
              >
                Add Flight
              </button>
              {rootStore.adminStore.getRoleName.toLowerCase() !== "admin" && (
                <div style={{ position: "relative", display: "inline-block" }}>
                  <select
                    className="org-list"
                    style={{
                      cursor:"pointer",
                      appearance: "none",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                      padding: "10px 8px",
                      color: "#4B628A",
                      backgroundColor: "#E9F2FF",
                      width: "148px",
                      borderRadius: "8px",
                      lineHeight: "20px",
                      marginLeft: "15px",
                      fontFamily: "Inter",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: "500",
                      border: "unset",
                      paddingRight: "2rem",
                      outline: "none",
                    }}
                    onClick={toggleDropdown}
                    onBlur={() => setIsOpen(false)}
                    onChange={(e) => {
                      rootStore.flightsStore.handleUserOId(e.target.value);
                      setCurrentPage(1);
                    }}
                    value={rootStore.flightsStore.getUserOId}
                  >
                    {/* <option disabled={true} style={{color:"#fff"}}>Please Select Organization</option> */}
                    {allOptions}
                    <option
                      style={{
                        cursor:"pointer",
                        color: "#333",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "100px",
                        fontFamily: "Inter",
                        fontSize: "12px",
                        fontStyle: "normal",
                        fontWeight: "500",
                        lineHeight: "16px",
                        padding: "12px 20px",
                        height: "300px",
                        top: "calc(100% + 5px)",
                      }}
                      value=""
                    >
                      Select All{""}
                    </option>
                  </select>

                  <img
                    className={
                      rootStore.adminStore.getUsersActionMenu
                        ? "rotate180"
                        : "rotate0"
                    }
                    style={{
                      position: "absolute",
                      right: "8px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      width: "24px",
                      height: "24px",
                      pointerEvents: "none",
                    }}
                    src={userActionDropdown}
                    alt="Dropdown Icon"
                  />
                </div>
              )}
              <Box className="filter-icon-shape" ref={filterDropdownRef}>
                <img
                  src={filtericon}
                  alt="Filter"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowFilterOptions(!showFilterOptions)}
                />
                {showFilterOptions && (
                  <Box className="dropdown">
                    <ul className="list">
                      <li onClick={() => sortFlights("newest")}>Newest</li>
                      <li onClick={() => sortFlights("oldest")}>Oldest</li>
                    </ul>
                  </Box>
                )}
              </Box>
            </div>
          </div>
        </div>
        <div className="over">
          <div className="table">
            <DataTable
              className="flight-datatable"
              step={itemsPerPage}
              paginate={false}
              data={sortedFlightList}
              resizeable
              columns={[
                {
                  property: "TailNumber",
                  header: (
                    <Text style={{textAlign: "center"}}>
                      {" "}
                      {rootStore.adminStore.getRoleName.toLowerCase() !==
                      "admin"
                        ? "Tail Number"
                        : "Registration"}
                    </Text>
                  ),
                  primary: true,
                  render: (item) => <Text style={{textAlign: "center"}}>{item.tailNumber}</Text>,
                },
                {
                  property: "MSN",
                  header: <Text style={{textAlign: "center"}}>MSN</Text>,
                  primary: true,
                  render: (item) => <Text style={{textAlign: "center"}}>{item.msn}</Text>,
                },
                {
                  property: "FleetType",
                  header: <Text style={{textAlign: "center"}}>Fleet Type</Text>,
                  primary: true,
                  render: (item) => <Text style={{textAlign: "center"}}>{item.fleetType}</Text>,
                },
                // {
                //   property: "Date",
                //   header: <Text>Date</Text>,
                //   primary: true,
                //   render: (item) => (
                //     <Text>
                //       {" "}
                //       {item.createdAt
                //         ? format(new Date(item.createdAt), "MM/dd/yyyy")
                //         : ""}
                //     </Text>
                //   ),
                // },
                // {
                //   property: "Time",
                //   header: <Text>Time</Text>,
                //   primary: true,
                //   render: (item) => (
                //     <Text>
                //       {item.createdAt
                //         ? format(new Date(item.createdAt), "hh:mm a")
                //         : ""}
                //     </Text>
                //   ),
                // },
                {
                  property: "Wi-fi Provider",
                  header: <Text style={{textAlign: "center"}}>Wi-fi Provider</Text>,
                  primary: true,
                  render: (item) => <Text style={{textAlign: "center"}}>{item.wifiProvider}</Text>,
                },
                ...(rootStore.adminStore.getRoleName.toLowerCase() !== "admin"
                  ? [
                      {
                        property: "Organization",
                        header: <Text style={{textAlign: "center"}}>Organization</Text>,
                        primary: true,
                        render: (item) => <Text style={{textAlign: "center"}}>{item.organization.name}</Text>,
                      },
                    ]
                  : []),
                {
                  property: "Action",
                  header: <Text style={{ textAlign: "center" }}>Action</Text>,
                  primary: true,
                  render: (item) => (
                    <button
                      className="new"
                      style={{ alignSelf: "center", paddingLeft: 10, border: "none", cursor: "pointer" }}
                      onClick={() => toggleEditForm(item.id)}
                    >
                      <img className="editsquare" src={editsquare} alt="Edit" />
                    </button>
                  ),
                },
              ]}
            />
          </div>
        </div>
        {totalPages > 1 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalItems={totalItems}
            onPageChange={handlePageChange}
          />
        )}
        {rootStore.flightsStore.getFlightlist.length === 0 ? (
          <div className="spinner-container">
            <img src={NoDataFound} />
            <p>No Data Found</p>
          </div>
        ) : (
          <></>
        )}
      </Box>

      {isAddFlightOpen && (
        <AddFlight onClose={() => setIsAddFlightOpen(false)} />
      )}

      {isEditFormOpen && (
        <FlightEditForm
          flight={flightToEdit}
          onClose={() => setIsEditFormOpen(false)}
        />
      )}
    </>
  );
});

export default Flights;
